import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import CancellationExperience from "./CancellationExperience";
import CancellationAccommodation from "./CancellationAccommodation";
import CancellationAccommodationEjunifer from "./CancellationAccommodationEjunifer";
import BookingGuest from "./BookingGuest";
import { packageForMyBookingFunc } from "../../AdminPackageDetails/PackageShowcase/commonFunction";

const borderColor = "#F5F5F5";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
    alignItems: "center",
  
    fontWeight: "bold",
    overflowY: "scroll",
    justifyContent: "center",
    marginBottom:5,
  },
  refrence: {
    width: "20%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    
    padding: 5,
    fontSize: 9,
    // color: "#374151",
  },
  description: {
    width: "25%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    padding: 5,
    fontSize: 9,
    // color: "#374151",
  },
  details: {
    width: "25%",
    textAlign: "left",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    padding: 5,
    fontSize: 9,
    // color: "#374151",
  },
  service_date: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
   padding: 5,
    fontSize: 9,
    // color: "#374151",
  },
  rate: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
    padding: 5,
    fontSize: 9,
    // color: "#374151",
  },
  cancellationpolicy: {
    fontSize: 9,
    lineHeight: 1.5,
  },
});

const InvoiceTableRow = ({ items }) => {
  var items1 = JSON.stringify(items);
  var items2 = JSON.parse(items1);
  var items3 = JSON.parse(items2);

  const packageDetails = packageForMyBookingFunc(items3?.child);
  const isPackage = packageDetails.is_package;

  const rows =
    items3.child != null &&
    items3.child.map((item) => (
      <View key={item.booking_refrence_id}>
        <View style={styles.row}>
          <Text style={styles.refrence}>
            {item.booking_source == 1
              ? item.booking_refrence_id + " - " + item.ReservationLocation
              : item.booking_source == 2
              ? item.booking_refrence_id + " - " + item.hl_booking_id
              : item.booking_refrence_id}
          </Text>
          <Text style={styles.description}>
            {item.rateplan_name + "(" + item.item_name + ")"}
          </Text>
          <Text style={styles.details}>
            {item.rateplan_name}
            {item?.pickup_transfer &&
              `${item.pickup_transfer} to ${item.drop_transfer}`}
          </Text>
          <Text style={styles.service_date}>
            {item.type == "accomodation"
              ? moment(item.booking_checked_in).format("D MMM Y") +
                " - " +
                moment(item.booking_checked_out).format("D MMM Y")
              : moment(item.tour_booking_date).format("D MMM Y")}
          </Text>
          <Text style={styles.rate}>
            {!isPackage ? item.total.slice(5, 13) : "-"}
          </Text>
        </View>
        <BookingGuest invoice={item}  />
        {!isPackage && (
          <>
            {item.type != "accomodation"
              ? item?.cancellation_policy != null && (
                  <CancellationExperience invoice={item} />
                )
              : item.cancellation_policy_ejunifer != null
              ? item.cancellation_policy_ejunifer != null && (
                  <CancellationAccommodationEjunifer invoice={item} />
                )
              : item.cancellation_policy != null && (
                  <CancellationAccommodation invoice={item} />
                )}
          </>
        )}
      </View>
    ));

  return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;
